<template>
    <div class="broadcast-list-more-actions">
        <ds-dropdown
            disable-scroll
            icons
            position="bottom-end"
        >
            <template #default>
                <ds-icon-button name="more-vertical" />
            </template>

            <template #menu>
                <ul class="dropdown-menu-list">
                    <li class="dropdown-menu-item" @click="openLegacyBroadcastReport">
                        <ds-icon name="external-link" />
                        {{ $options.MESSAGE_CONSTANTS.OPEN_REPORT }}
                    </li>
                </ul>
            </template>
        </ds-dropdown>
    </div>
</template>

<script>
export const MESSAGE_CONSTANTS = {
    OPEN_REPORT: 'Legacy broadcast report',
};

const LEGACY_REPORT_URL = '/Reports/searchTemplate.jsp?reportClass=EmailBatchSearch&view=resultsPage';

export default {
    MESSAGE_CONSTANTS,

    methods: {
        openLegacyBroadcastReport() {
            window.open(LEGACY_REPORT_URL, '_blank', 'noopener,noreferrer');
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.broadcast-list-more-actions {
    --dropdown-minwidth: #{px-to-rem(300)};
    padding-right: $spacing-100;
}
</style>
